import { useState } from 'react';
import { Search, UserCheck, Card, Box, Route, Scale, Bell, Wallet } from '../Icons';

const tabs = {
  senders: {
    label: 'I want to send',
    steps: [
      { Icon: Search, title: 'Search your route', text: 'Enter source, destination and date. See travellers by journey, travel mode and free capacity. No personal data is exposed.' },
      { Icon: UserCheck, title: 'Pick a traveller', text: 'Choose the traveller that fits your item and timing, then submit a request describing what you are sending.' },
      { Icon: Card, title: 'Pay securely', text: 'Complete payment on the platform. Funds are held safely while our team reviews your request.' },
      { Icon: Box, title: 'Hand over & track', text: 'Once the admin officially assigns the traveller, you get handover details and status updates until delivery.' },
    ],
  },
  travellers: {
    label: "I'm travelling",
    steps: [
      { Icon: Route, title: 'Register your journey', text: 'Add source, destination, travel date and travel mode for each upcoming trip.' },
      { Icon: Scale, title: 'Set your capacity', text: 'Tell us how much space or weight you can spare. You decide what you are comfortable carrying.' },
      { Icon: Bell, title: 'Get assigned', text: 'Our admin team reviews requests and assigns verified, paid-for items to your trip. No haggling with strangers.' },
      { Icon: Wallet, title: 'Deliver & earn', text: 'Carry the item, confirm delivery, and get paid for space that would otherwise go unused.' },
    ],
  },
};

export default function HowItWorks() {
  const [active, setActive] = useState('senders');
  const { steps } = tabs[active];

  return (
    <section className="section" id="how">
      <div className="container">
        <div className="section__head reveal">
          <span className="kicker">How it works</span>
          <h2>Two sides, one simple journey</h2>
          <p>Whether you are sending something or have space to spare, you can get started in minutes.</p>
        </div>

        <div className="tabs reveal" role="tablist" aria-label="Choose your role">
          {Object.entries(tabs).map(([key, t]) => (
            <button
              key={key}
              role="tab"
              aria-selected={active === key}
              className={`tabs__btn ${active === key ? 'is-active' : ''}`}
              onClick={() => setActive(key)}
            >
              {t.label}
            </button>
          ))}
          <span className={`tabs__pill ${active === 'travellers' ? 'is-right' : ''}`} aria-hidden="true" />
        </div>

        <ol className="steps" key={active}>
          {steps.map(({ Icon, title, text }, i) => (
            <li className="step" key={title} style={{ '--i': i }}>
              <div className="step__num">0{i + 1}</div>
              <div className="step__icon"><Icon /></div>
              <h3>{title}</h3>
              <p>{text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
